/**
 * Resolve o domínio público canônico do tenant a partir de
 * `empresa.url_canonica` (parâmetro explícito cadastrado em `parametros`,
 * rotina "SEO"), evitando depender de `window.location.origin` — que fica
 * incorreto quando a página é servida pelo pipeline de pré-renderização de
 * bots (seoBot.js), cujo Puppeteer navega internamente via IP ao invés do
 * domínio público.
 */
export function getCanonicalOrigin(urlCanonica, fallbackOrigin) {
  if (!urlCanonica) return fallbackOrigin;
  return urlCanonica.replace(/\/$/, '');
}
